import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
// import { validations } from '../../../../config/validations/validations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { handlePortReturnRequest } from '../../../../store/SendMessageSlice';

const ReturnRequest: React.FC<any> = (props) => {
  const { openReturnModal, handleReturnRequest, openReturnData, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [providerList, setProviderList] = useState<any>([]);

  useEffect(() => {
    if (openReturnData) {
      form.setFieldValue('number', openReturnData?.number);
      form.setFieldValue('to_provider', openReturnData?.to_provider);
      setProviderList([
        {
          value: openReturnData?.from_provider,
          label: openReturnData?.from_provider,
        },
        {
          value: openReturnData?.to_provider,
          label: openReturnData?.to_provider,
        },
      ]);
    }
  }, [openReturnData, form]);

  const handleSubmit = (data) => {
    const payload = {
      request_id: openReturnData?.request_id,
      ...data,
    };

    dispatch(handlePortReturnRequest(payload))
      .then(() => {
        handleReturnRequest();
        getList();
      })
      .catch(() => {
        handleReturnRequest();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openReturnModal}
        destroyOnClose
        width={800}
        onCancel={handleReturnRequest}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={openReturnData?.return_response ? 'Return Request Status' : 'Return Request'}
      >
        {openReturnData?.return_response ? (
          <table
            className="reportTable"
            width={'100%'}
          >
            <thead>
              <tr>
                <th>Action Name</th>
                <th>Approval</th>
                <th>ACK CODE</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{openReturnData?.return_response?.action_name}</td>
                <td>{openReturnData?.return_response?.approval?.approvalInd}</td>
                <td>{openReturnData?.return_response?.ack_cod}</td>
                <td>{openReturnData?.return_response?.return_date_ISR}</td>
              </tr>
            </tbody>
          </table>
        ) : (
          <FormBox
            className="filterForm"
            form={form}
            onFinish={handleSubmit}
            onChange={handleChange}
            validateTrigger={['onBlur', 'onInput']}
            autoComplete="off"
          >
            <Row
              gutter={20}
              align={'top'}
            >
              <Col
                xs={24}
                md={12}
              >
                <InputBox.Text
                  label="Request Number"
                  name={'number'}
                  disabled
                />
              </Col>
              <Col
                xs={24}
                md={12}
              >
                <InputBox.Select
                  label="Select Provider"
                  name={'to_provider'}
                  options={{
                    list: providerList && providerList,
                    valueKey: 'value',
                    textKey: 'label',
                  }}
                />
              </Col>
              <Col
                xs={12}
                md={12}
                lg={6}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </FormBox>
        )}
      </Modal>
    </>
  );
};

export default ReturnRequest;
